import { Component, OnInit, inject } from '@angular/core';
import {environment} from "../../../environments/environment";
import {DataService} from "../../services/data.service";
import {LocalStorageService} from "../../services/local-storage.service";
import {Router, RouterLink, RouterLinkActive} from "@angular/router";
import {AccessService} from "../../services/access.service";
import {Subscription} from "rxjs";
import {MessageService} from "../../services/message.service";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    imports: [
        RouterLink,
        RouterLinkActive,
        NgIf
    ],
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private localStorageService = inject(LocalStorageService);
    private router = inject(Router);
    private messageService = inject(MessageService);

    countDeleted = 0;
    currentApplicationVersion = environment.appVersion;
    messageSubscription$: Subscription;

    ngOnInit(): void {
        this.messageSubscription$ = this.messageService.getMessage().subscribe(() => {
            this.loadTrashed();
        });

        this.loadTrashed();
    }

    loadTrashed(): void {
        this.dataService.request("Task/countDeleted").subscribe(response => {
            this.countDeleted = response.count;
        });
    }

    logout(event): void {
        event.preventDefault();
        this.dataService.request("User/logout").subscribe(() => {
            this.localStorageService.removeItem('token');
            this.accessService.token = '';
            this.accessService.user = null;
            this.router.navigate(['/login']);
        });
    }

    hide(): void {
        let element = document.getElementById('sidebarMenu');
        element.classList.remove("show");
    }

}
